import React from "react";
import { connect } from "react-redux";

import App from "next/app";
import Head from "next/head";

import "abortcontroller-polyfill/dist/polyfill-patch-fetch";

import { Cookie, CustomContainer } from "components/atoms/DependencyHelper";
import MainContainer from "components/atoms/container/MainContainer";
import ButtonWithIcon from "components/atoms/buttons/buttonWithIcon/ButtonWithIcon";
import Loader from "components/atoms/loader/loader";
import InterNalSearch from "components/organisms/InternalSearch/InterNalSearch";
import UpgradeErrorModal from "components/molecules/upgradeErrorModal/upgradeErrorModal";
import UpgradeBanner from "components/molecules/upgradeBanner/UpgradeBanner";
import UpgradeContainer from "components/organisms/upgradeContainer/UpgradeContainer";
import Footer from "components/organisms/footer/Footer";
import Headerfragment from "components/molecules/headerFragment/headerFragment";
import GetHelp from "components/atoms/getHelp/getHelp";
import { MiniAppHeader } from "components/miniApp";

import withReduxStore from "../lib/with-redux-store";
import "../styles/main.scss";

import { handleSlice } from "Redux/actions/breadcrumbAction";
import {
  showGuestCart,
  deleteItemsFromCart
} from "Redux/actions/cartAction";
import {
  setProfileData,
  setProfileLoading,
  setReLogin,
  setMiniApp,
  setBackEnabled,
} from "Redux/actions/navAction";
import {
  displayHideUpgradeTopbanner,
  displayHideUpgradeTopbannerModal,
  clearUpgradeJourney,
  displayHideUpgradeModal
} from "Redux/actions/upgradeAction";


import { AnalyticsWrapper } from "services/analyticsUtag";
import { link, getUtagData } from "services/analyticsUtag";
import { resetFiltersOnStopUpgrade } from "services/upgradeService";

import ajaxService from "utils/ajaxServices";
import microService from "utils/microServices";
import { Features } from "utils/featuresService";
import {
  getSessionStorage,
  updateSessionStorage,
  getCookieValue,
  setCookieConsentWrapper,
  showSpinner,
  hideSpinner,
  updateCartExpiry,
  cartUpdateEvent,
} from "utils/helperServices";
import { Logger } from "utils/logger";

import labels from "../config/labels";
import { guestCreateEmptyCart, persistCart } from "../config/queries";
import config, { EnvConfig } from "../config/index";

const isServer = () => typeof window === "undefined";
const k8sConfig = typeof window === "undefined" ? require("config") : "";

class MyApp extends App {
  constructor() {
    super();
    this.pageStoreHistory = {
      history: [
        {
          pathname: "/",
          asPath: "/",
        },
      ],
      prevPageName: "/",
    };
    this.state = {
      isBannerVisible: false,
      domLoaded: false,
      miniAppBackComponent: null
    };
    this.showTopBanner = this.showTopBanner.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.closeTopBannerModal = this.closeTopBannerModal.bind(this);
    this.closeBannerAndModal = this.closeBannerAndModal.bind(this);
    this.redirectToDeals = this.redirectToDeals.bind(this);
    this.clearAndOpenBannerModal = this.clearAndOpenBannerModal.bind(this);
  }

  componentWillMount() {
    this.props.setProfileLoading(true);
  }

  componentWillUnmount() {
    if (this.props.isMiniApp) {
      this.props.router.events.off(
          "routeChangeStart",
          this.handleMiniAppHomeClick
      );
    }
  }

  async componentDidMount() {

    const userLoggedIn = this.props.userLoggedIn;
    const reLogin = this.props.reLogin;
    this.pageNavigationHistory();

    const JWTtoken = getCookieValue("vod-web-auth-token");
    const authtoken = getCookieValue("auth_token");
    const isMiniAppCookie = getCookieValue("miniApp") === "true";

    if (userLoggedIn && !authtoken) {
      this.props.store.dispatch(clearUpgradeJourney(true));
      this.props.setProfileData(null);
    }

    let cartId = getCookieValue("cart_id");
    if (cartId === undefined) {
      cartId = await this.createEmptyCart();
    }

    ///  Profile sync local login purpose
    // Cookie.set(
    //   "vod-web-auth-token",
    //   "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MDIwMzIyOTAsInVzZXJfbmFtZSI6IlpBMTMwOTk3IiwiYXV0aG9yaXRpZXMiOlsiUk9MRV9VU0VSIiwiUk9MRV9TU08iXSwianRpIjoiZDI1ZDMyY2MtODkwYy00ZWFlLTgwMGMtNTA5OGU0ODZkZDBjIiwiY2xpZW50X2lkIjoicmVzdGFwaSIsInNjb3BlIjpbIm9wZW5pZCJdfQ.NhWbJNp6Rgta0IK9bmhvjfTTM5DajLGnrskfJDD6H7PTeG02FKi1MqujT5eStwY8b4wM7aqaprlDCHYgRcuvZEUw5vJQkGosBCGVjP0jcDe0Ezr52ejjLL6ePbNdirnuN0-8wKUFdEXoEaDZJQDo3bJj8QV6_9ZTfyC0OvoC0eLMlUUqt5s8DmOfH_KR0ovtxqPYQDz8APY4umSGVhULSIOjdfkZwtMwDSusm8h9sNWAyqzJUV5u4oUZNkpZuFXbSYhHx_c68MGQVD0tO0exD4o3z0lyH5lWUa_JOy20qgKd9XnBhCrF-l7oHDhY3Qvksn7LxQOKE15OwXsPZ78q-g"
    // );

    if (JWTtoken && (!userLoggedIn || reLogin || isMiniAppCookie)) {
      showSpinner();
      let params;

      if (cartId) {
        params = {
          guestCartId: cartId,
        };
      }

      const profileInfoRequest = await microService.post(
          "api",
          "profileSync",
          {},
          params
      );

      const profileInfo = profileInfoRequest.response?.data?.result;

      if (
          !profileInfoRequest.fail &&
          profileInfo &&
          profileInfo?.result &&
          profileInfo?.result?.magentoProfileResponse &&
          profileInfo?.result?.magentoProfileResponse[0] &&
          profileInfo?.result?.profileSubscriptionResponse &&
          profileInfo?.result?.profileSubscriptionResponse?.subscriptions
      ) {
        let oAuthToken =
            profileInfo?.result?.magentoProfileResponse[0]?.OAuthTokenDetails[0]
                ?.OAuthToken;
        cartId = profileInfo?.result?.magentoProfileResponse[0]?.mergedCartID;

        setCookieConsentWrapper(
            "auth_token",
            [config.cookie_category.strictly_necessary],
            `document.cookie='auth_token=${oAuthToken};path=/'`
        );
        setCookieConsentWrapper(
            "cart_id",
            [config.cookie_category.strictly_necessary],
            `document.cookie='cart_id=${cartId};path=/'`
        );

        Cookie.remove("profileSyncFail");

        this.props.setProfileData(profileInfo);
        this.props.setReLogin(false);

        const selectedUpgradeMsisdn = this.props.upgrade.selectedUpgradeMsisdn;
        const selectedUpgradeUnmaskedMsisdn = this.props.upgrade.unMaskedMsisdn;
        // let isUpgradeMsisdnLinked = true;

        // if (selectedUpgradeMsisdn || selectedUpgradeUnmaskedMsisdn) {

        //   isUpgradeMsisdnLinked = profileInfo.result.profileSubscriptionResponse.subscriptions.subscriptions.some(
        //       (subscription) => subscription.subscriptionId === selectedUpgradeMsisdn || subscription.subscriptionId == selectedUpgradeUnmaskedMsisdn
        //   );
        // }

        // if (!isUpgradeMsisdnLinked){

        //   const shoppingUrlPrefix = config.envConfigs[config.env].shoppingUrlPrefix;

        //   this.props.store.dispatch(clearUpgradeJourney());

        //   this.props.router.push(`${shoppingUrlPrefix}/upgrade`);

        //   return;
        // }

        /* reset upgrade journey after success login */
        if (
            (this.props.upgrade.upgradeCheckDone || this.props.upgrade.allUpgradesData.length)
            && (!selectedUpgradeMsisdn || !selectedUpgradeUnmaskedMsisdn)
        ) {
          this.props.store.dispatch(clearUpgradeJourney());
        }
        cartUpdateEvent();
      } else {

        let SyncBackInfo = JSON.stringify(profileInfoRequest);

        Logger.info(
            `Profile Sync failed`,
            this.pageStoreHistory.prevPageName,
            {
              ServiceResponseCode: profileInfoRequest.error?.status,
              response: SyncBackInfo,
            },
            { result_code: profileInfoRequest.error?.status }
        );

        setCookieConsentWrapper(
            "profileSyncFail",
            [config.cookie_category.strictly_necessary],
            `document.cookie='profileSyncFail=true;path=/'`
        );

        Cookie.remove("vod-web-auth-token", {
          path: "/",
          domain: ".vodacom.co.za",
        });
        Cookie.remove("auth_token");
      }
      hideSpinner();
    } else if (!authtoken) {
      Cookie.remove("profileSyncFail");
      this.props.setProfileData(null);
      this.props.setReLogin(false);
    }

    this.props.showGuestCart(cartId);
    this.props.setProfileLoading(false);

    if (!this.props.isMiniApp) {
      return;
    }

    this.props.router.events.on(
        "routeChangeStart",
        this.handleMiniAppHomeClick
    );
  }

  handleMiniAppHomeClick = (url) => {
    // when isMiniApp = true, we don't ever want to navigate to the home page
    // when navigating to the home page, we will route to the products page by default

    if (url === "/") {
      this.props.router.push("/shopping/products");
      throw `Route change to "${url}" was aborted (this error can be safely ignored). See https://github.com/zeit/next.js/issues/2476.`;
    }
  };

  handleBack() {
    const pageHistory = getSessionStorage(
        labels.Session_Keys.lbl_page_visit_history
    );
    showSpinner();
    window.history.go(-1);
    pageHistory.pop();
    updateSessionStorage(
        labels.Session_Keys.lbl_page_visit_history,
        pageHistory
    );
    hideSpinner();
  }

  async componentDidUpdate() {
    if (Object.keys(this.props.features || {}).length > 0) {
      Features.init(this.props.features);
    }

    let splitRoute =
        this.props.router?.pathname?.replace(/ *\[[^)]*\] */g, "").split("/") ||
        [];

    let pageName = "unknown";

    if (splitRoute.length >= 2) {
      pageName =
          splitRoute[splitRoute.length - 1] || splitRoute[splitRoute.length - 2];
    }

    Logger.setContext("Page Logs", {
      page: pageName,
    });

    let cartId = getCookieValue("cart_id");

    if (cartId === undefined) {
      this.createEmptyCart();
    }

    this.pageNavigationHistory();

    if (this.props.salesMiniAppEnabled) {
      if (
          this.props.router?.query?.miniApp ||
          getCookieValue("miniApp") === "true"
      ) {
        this.props.setMiniApp(true);

        let currDate = new Date();
        currDate.setMonth(currDate.getMonth() + 1);

        setCookieConsentWrapper(
            "miniApp",
            true,
            `document.cookie='miniApp=true;expires=${currDate};domain=${EnvConfig.cookieDomain};path=/'`
        );

        Logger.setTags({
          mini_app: true,
        });

        !this.state.miniAppBackComponent &&
        this.setState({
          miniAppBackComponent: this.createMiniAppBackButton(),
        });
      } else {
        this.props.setMiniApp(false);
      }
    }

    let PageVisitHistory = this.props.router.asPath;
    let current_page_history =
        getSessionStorage(labels.Session_Keys.lbl_page_visit_history) || [];

    if (
        PageVisitHistory !== current_page_history[current_page_history.length - 1]
    ) {
      current_page_history.push(PageVisitHistory);
      updateSessionStorage(
          labels.Session_Keys.lbl_page_visit_history,
          current_page_history
      );
    }

    if (current_page_history.length > 1) {
      this.props.setBackEnabled(!this.props.router?.query?.fromMiniAppPayment);
    } else {
      this.props.setBackEnabled(false);
    }
  }

  createMiniAppBackButton = () => {
    const imagePrefix = EnvConfig.imagePrefix;

    return (
        <CustomContainer className="container">
          <ButtonWithIcon
              className={"mini_app_back_button"}
              labelText={"Back"}
              img_url_inactive={`${imagePrefix}/assets/images/caret-back.svg`}
              img_url_active={`${imagePrefix}/assets/images/caret-back.svg`}
              img_url_disable={`${imagePrefix}/assets/images/disable-caret-back.svg`}
              clickHandler={this.handleBack}
          />
        </CustomContainer>
    );
  };

  async createEmptyCart() {
    if (this.emptyCartRequested) return;
    this.emptyCartRequested = true;
    const authtoken = getCookieValue("auth_token");
    const persistCartResponse = await ajaxService.fetchGraphQLPOSTRequest(
        persistCart
    );
    const persistTime =
        persistCartResponse?.persist_cart?.persistent_enable &&
        persistCartResponse?.persist_cart?.persistent_lifetime
            ? persistCartResponse?.persist_cart?.persistent_lifetime
            : null;
    if (persistTime) {
      setCookieConsentWrapper(
          "persist_time",
          [config.cookie_category.strictly_necessary],
          `document.cookie='persist_time=${persistTime};path=/'`
      );
    }
    const emptyCartForGuest = await ajaxService.fetchGraphQLPOSTRequest(
        guestCreateEmptyCart
    );
    const cartId = emptyCartForGuest?.createEmptyCart;
    if (!authtoken) {
      updateCartExpiry(cartId);
    } else {
      setCookieConsentWrapper(
          "cart_id",
          [config.cookie_category.strictly_necessary],
          `document.cookie ='cart_id=${cartId};path=/'`
      );
    }
    cartUpdateEvent();
    return cartId;
  }

  pageNavigationHistory() {
    this.pageStoreHistory = getSessionStorage(
        labels.Session_Keys.lbl_breadCrumb
    )
        ? getSessionStorage(labels.Session_Keys.lbl_breadCrumb)
        : this.pageStoreHistory;
    const asPath = this.props.router.asPath;
    const pathName = this.props.router.pathname;
    var index;

    if (
        this.pageStoreHistory &&
        this.pageStoreHistory.history &&
        this.pageStoreHistory.history.length &&
        pathName !== this.pageStoreHistory.prevPageName
    ) {
      this.pageStoreHistory.history.forEach((page, i) => {
        if (
            page.pathname == this.props.router.pathname ||
            page.pathname == "/shopping" + this.props.router.query.api?.[0] ||
            page.asPath === this.props.router.asPath ||
            page.pathname.split("/shopping")[1] ==
            this.props.router.pathname.split("/shopping")[1] ||
            page.asPath.split("/shopping")[1] ==
            this.props.router.asPath.split("/shopping")[1] ||
            page.pathname == "/shopping" + this.props.router.query.api?.[0] ||
            page.asPath.split("shopping/")[1] ==
            "/shopping" + this.props.router.query.api?.[0]
        ) {
          index = i;
        }
      });
      if (index !== -1 && this.pageStoreHistory.history.length > 0) {
        if (this.props.breadcrumbDetails === true) {
          this.pageStoreHistory.history.splice(
              index,
              this.pageStoreHistory.history.length - index
          );
          this.props.handleSlice(false);
        } else {
          index !== undefined && this.pageStoreHistory.history.splice(index, 1);
        }
      }
      this.pageStoreHistory = {
        history: [
          ...this.pageStoreHistory.history,
          {
            asPath: asPath,
            pathname: pathName === "/[...api]" ? asPath : pathName,
          },
        ],
        prevPageName: pathName === "/[...api]" ? asPath : pathName,
      };
      updateSessionStorage(
          labels.Session_Keys.lbl_breadCrumb,
          this.pageStoreHistory
      );
    } else if (!this.pageStoreHistory) {
      // Set Initial Page
      updateSessionStorage(labels.Session_Keys.lbl_breadCrumb, {
        history: [
          {
            pathname: "/",
            asPath: "/",
          },
        ],
        prevPageName: "/",
      });
    }
  }

  showTopBanner() {
    this.props.store.dispatch(displayHideUpgradeTopbannerModal(true));
    link({
      link_type: "o",
      link_name: `${getUtagData(["page_name"]).page_name}: ${
          labels.lbl_top_banner.lbl_btn.lbl_see_detail
      }`,
    });
  }

  removeUpgradeDealFromCart() {
    const { sku: upgradeDealSKU } = this.props.upgrade?.devicePrice;
    const reduxState = this.props.store.getState();
    const cartItems = reduxState?.cartDetails.cartProductItems
    const upgradeCartItem = Array.isArray(cartItems)
        ? cartItems.find(ci => ci?.product.sku === upgradeDealSKU)
        : null;

    const cartId = getCookieValue("cart_id");

    if (!upgradeCartItem || !upgradeCartItem.id || !cartId) {
      return;
    }

    this.props.store.dispatch(
        deleteItemsFromCart(cartId, upgradeCartItem.id)
    );
  }

  closeTopBannerModal() {
    this.props.store.dispatch(displayHideUpgradeTopbannerModal(false));
    link({
      page_tool_event: "use",
      page_tool_name: `${getUtagData(["page_name"]).page_name}: dismiss`,
    });
  }

  closeBannerAndModal() {
    this.props.store.dispatch(displayHideUpgradeTopbannerModal(false));
    this.props.store.dispatch(displayHideUpgradeTopbanner(false));

    this.props.store.dispatch(clearUpgradeJourney());
    this.removeUpgradeDealFromCart();

    resetFiltersOnStopUpgrade(this.props?.router?.route);
    link({
      page_tool_event: "use",
      page_tool_name: `${getUtagData(["page_name"]).page_name}: ${
          labels.lbl_top_banner.lbl_btn.lbl_stop_upgrade
      }`,
    });
    hideSpinner();
  }

  clearAndOpenBannerModal() {
    this.closeBannerAndModal();
    this.props.store.dispatch(displayHideUpgradeModal(true));
  }

  redirectToDeals() {
    this.props.store.dispatch(displayHideUpgradeTopbannerModal(false));
    link({
      page_tool_event: "use",
      page_tool_name: `${getUtagData(["page_name"]).page_name}: ${
          labels.lbl_top_banner.lbl_btn.lbl_recommended_deals
      }`,
    });
    showSpinner();
    this.props.router.push(`/shopping/upgrade`).then(() => {
      hideSpinner();
    });
  }

  render() {
    const {
      Component,
      pageProps,
      hideNavItems,
      upgrade,
      upgradeChecksEnabled,
      isMobileFilter,
      leadInterceptEnabled,
      hideFooter,
      isMiniApp,
      isBackEnabled,
      salesMiniAppMenuEnabled,
    } = this.props;

    const env = config.env;
    const imagePrefix = config.envConfigs[env].imagePrefix;
    let respSticky =
        this.props.router.route.includes("product-details") ||
        this.props.router.route.includes("deal-details-page");

    return (
        <>
          <Head>
            {pageProps?.previewMode && (
                <meta name="googlebot" content="noindex" />
            )}


            <meta
                name="viewport"
                content="width=device-width, initial-scale=1.0"
            ></meta>

            <link
                rel="preload"
                href="https://vjs.zencdn.net/7.8.2/video-js.css"
                as="style"
                onLoad="this.onload=null;this.rel='stylesheet'"
            />
            <noscript>
              <link
                  rel="stylesheet"
                  href="https://vjs.zencdn.net/7.8.2/video-js.css"
              />
            </noscript>
            <link
                rel="preload"
                href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.0.0/animate.min.css"
                as="style"
                onLoad="this.onload=null;this.rel='stylesheet'"
            />
            <noscript>
              <link
                  rel="stylesheet"
                  href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.0.0/animate.min.css"
              />
            </noscript>
            <link rel="icon" href={`${imagePrefix}/assets/images/favicon.ico`} />
            {isMiniApp && <title>Shop Online | Vodacom</title>}
          </Head>

          {hideNavItems && <InterNalSearch />}
          <Loader />

          <CustomContainer
              className={`${
                  this.props.router.route.includes("checkout") || isMobileFilter
                      ? "d-none"
                      : ""
              }`}
          >
            {!isMiniApp ? (
                <Headerfragment />
            ) : (
                salesMiniAppMenuEnabled && (
                    <MiniAppHeader router={this.props.router} />
                )
            )}
          </CustomContainer>

          {!this.props.router.route.includes("checkout") ? (
              <>
                {upgradeChecksEnabled && upgrade.topBannerModal && (
                    <UpgradeErrorModal
                        show="true"
                        title={labels.lbl_top_banner.lbl_process_upgrade_title}
                        text={labels.lbl_top_banner.lbl_Process_upgrade}
                        cellphone={upgrade.msisdn}
                        outlineWhiteBtnLabel={
                          labels.lbl_top_banner.lbl_btn.lbl_stop_upgrade
                        }
                        solidBlackBtnLabel={
                          labels.lbl_top_banner.lbl_btn.lbl_recommended_deals
                        }
                        solidBlackBtnLabelSecond={
                          labels.lbl_top_banner.lbl_btn.lbl_start_upgrade
                        }
                        handleCancel={this.closeTopBannerModal}
                        handleRestart={this.clearAndOpenBannerModal}
                        outlineWhiteBtnAction={this.closeBannerAndModal}
                        solidBlackBtnAction={this.redirectToDeals}
                    />
                )}

                {!this.props.router.route.includes("forms") &&
                    isBackEnabled &&
                    isMiniApp &&
                    !isMobileFilter &&
                    this.state.miniAppBackComponent}

                <MainContainer
                    className={
                      isMiniApp && respSticky
                          ? "large_bottom_space"
                          : "medium_bottom_space"
                    }
                >
                  {upgradeChecksEnabled && <UpgradeBanner />}
                  <AnalyticsWrapper />
                  <Component {...pageProps} />
                  {upgradeChecksEnabled && <UpgradeContainer />}
                </MainContainer>
                {!isMiniApp && !isMobileFilter && <Footer />}
              </>
          ) : (
              <>
                <AnalyticsWrapper />
                <Component {...pageProps} />
              </>
          )}
          {!this.props.router.route.includes("forms") &&
          leadInterceptEnabled &&
          !hideFooter ? (
              <GetHelp
                  stacked={respSticky}
                  leadBucket={this.props.getHelpLeadBucket}
              />
          ) : (
              <></>
          )}
        </>
    );
  }
}

MyApp.getInitialProps = async ({ Component, ctx }) => {

  let features = {};

  try {
    features = await ajaxService.httpGet(
        "featureBaseUrl",
        "",
        "api",
        "features"
    );
  } catch (e) {
    console.log("app : features: error", e);
  }

  if (isServer()) {
    const upgradeChecksEnabled = k8sConfig.get("features.upgradeChecks");
    const leadInterceptEnabled = k8sConfig.get("features.leadIntercept");
    const salesMiniAppEnabled = k8sConfig.get("features.salesMiniApp");
    const shakaEnabled = k8sConfig.get("features.shaka");
    const salesMiniAppMenuEnabled = k8sConfig.get("features.salesMiniAppMenu");

    return {
      features: features,
      upgradeChecksEnabled: upgradeChecksEnabled === "true",
      leadInterceptEnabled: leadInterceptEnabled === "true",
      salesMiniAppEnabled: salesMiniAppEnabled === "true",
      shakaEnabled: shakaEnabled === "true",
      salesMiniAppMenuEnabled: salesMiniAppMenuEnabled === "true",
      pageProps: Component.getInitialProps
          ? await Component.getInitialProps(ctx)
          : {},
    };
  } else {
    return {
      features: features,
      upgradeChecksEnabled: features?.upgradeChecksEnabled,
      leadInterceptEnabled: features?.leadInterceptEnabled,
      salesMiniAppEnabled: features?.salesMiniAppEnabled,
      shakaEnabled: features?.shakaEnabled,
      salesMiniAppMenuEnabled: features?.salesMiniAppMenuEnabled,
      pageProps: Component.getInitialProps
          ? await Component.getInitialProps(ctx)
          : {},
    };
  }
};

const mapStateToProps = (state) => ({
  hideFooter: state.displayHideFooter.hideFooter,
  hideNavItems: state.navDetails.hideNavItems,
  breadcrumbDetails: state.SliceBreadcrumb.slice,
  userLoggedIn: state.navDetails.isUserLoggedIn,
  reLogin: state.navDetails.isReLogin,
  isMiniApp: state.navDetails.isMiniApp,
  isBackEnabled: state.navDetails.isBackEnabled,
  upgrade: state.upgrade,
  isMobileFilter: state.navDetails.isMobileFilter,
  getHelpLeadBucket: state.getHelp.getHelpLeadBucket,
});

export default withReduxStore(
    connect(mapStateToProps, {
      showGuestCart,
      setProfileData,
      setProfileLoading,
      setReLogin,
      setMiniApp,
      setBackEnabled,
      handleSlice,
      clearUpgradeJourney,
      displayHideUpgradeTopbanner,
      displayHideUpgradeTopbannerModal,
    })(MyApp)
);
